import { Divider, Label } from '@vinted/web-ui';
import SeparatedList from 'components/SeparatedList';
import { BUSINESS_TERMS_OF_SALE_URL, BUSINESS_TERMS_URL, COOKIE_POLICY_URL, HELP_SAFETY_URL, PRIVACY_POLICY_URL, TERMS_URL } from 'constants/routes';
import useTranslate from 'hooks/useTranslate';
import OtherLink from '../OtherLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const Policies = _ref => {
  let {
    impressumUrl,
    isBusinessAccountLinksVisible
  } = _ref;
  const translate = useTranslate('header.main_navigation.about.policies');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Label, {
      styling: Label.Styling.Wide,
      text: translate('title')
    }), /*#__PURE__*/_jsxs(SeparatedList, {
      separator: /*#__PURE__*/_jsx(Divider, {}),
      children: [/*#__PURE__*/_jsx(OtherLink, {
        title: translate('items.safety'),
        url: HELP_SAFETY_URL
      }), impressumUrl && /*#__PURE__*/_jsx(OtherLink, {
        title: translate('items.impressum'),
        url: impressumUrl
      }), /*#__PURE__*/_jsx(OtherLink, {
        title: translate('items.privacy_policy'),
        url: PRIVACY_POLICY_URL
      }), /*#__PURE__*/_jsx(OtherLink, {
        title: translate('items.terms_and_conditions'),
        url: TERMS_URL
      }), /*#__PURE__*/_jsx(OtherLink, {
        title: translate('items.cookie_policy'),
        url: COOKIE_POLICY_URL
      }), isBusinessAccountLinksVisible && /*#__PURE__*/_jsx(OtherLink, {
        title: translate('items.pro_terms_of_sale'),
        url: BUSINESS_TERMS_OF_SALE_URL
      }), isBusinessAccountLinksVisible && /*#__PURE__*/_jsx(OtherLink, {
        title: translate('items.pro_terms_of_use'),
        url: BUSINESS_TERMS_URL
      })]
    })]
  });
};

export default Policies;